webpackJsonp([35783957827783],{

/***/ 106:
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  return bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	module.exports = bytesToUuid;


/***/ }),

/***/ 107:
/***/ (function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && msCrypto.getRandomValues.bind(msCrypto));
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(107);
	var bytesToUuid = __webpack_require__(106);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(14);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var News = function (_Component) {
	  _inherits(News, _Component);
	
	  function News() {
	    _classCallCheck(this, News);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  News.prototype.rendermessage = function rendermessage(message) {
	    var uuidv4 = __webpack_require__(95);
	    return _react2.default.createElement(
	      'li',
	      { className: 'card-text', key: uuidv4() },
	      message
	    );
	  };
	
	  News.prototype.render = function render() {
	    var _this2 = this;
	
	    var t = this.props.t;
	
	    var messages = t('description');
	    var messages2 = t('description2');
	    var messages3 = t('description3');
	    var messages4 = t('description4');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'card-title' },
	            t('title')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'card-subtitle mb-2 text-muted' },
	            t('subtitle')
	          ),
	          messages.split('<br>').map(function (message) {
	            return _this2.rendermessage(message);
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'card-subtitle mb-2 text-muted' },
	            t('subtitle2')
	          ),
	          messages2.split('<br>').map(function (message) {
	            return _this2.rendermessage(message);
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'card-subtitle mb-2 text-muted' },
	            t('subtitle3')
	          ),
	          messages3.split('<br>').map(function (message) {
	            return _this2.rendermessage(message);
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'card-subtitle mb-2 text-muted' },
	            t('subtitle4')
	          ),
	          messages4.split('<br>').map(function (message) {
	            return _this2.rendermessage(message);
	          })
	        )
	      )
	    );
	  };
	
	  return News;
	}(_react.Component);
	
	News.propTypes = {
	  t: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactI18next.translate)('News')(News);
	module.exports = exports['default'];

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withAuthorization = __webpack_require__(23);
	
	var _withAuthorization2 = _interopRequireDefault(_withAuthorization);
	
	var _News = __webpack_require__(339);
	
	var _News2 = _interopRequireDefault(_News);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(_News2.default, null);
	};
	
	exports.default = (0, _withAuthorization2.default)(IndexPage);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-97cfca2a0909756cf8c3.js